module.exports = __webpack_public_path__ + "static/img/wild5.70fc5a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/wild5.png
// module id = IwVY
// module chunks = 0